import service from '@/store/services/settings/guidance-workplaces-service';

const state = {
    list: {},
    activityGuidance: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, guidanceWorkplace) => {
        state.guidanceWorkplace = guidanceWorkplace;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(guidanceWorkplace => {
                commit('SET_RESOURCE', guidanceWorkplace);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(guidanceWorkplace => {
                commit('SET_RESOURCE', guidanceWorkplace);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((guidanceWorkplace) => {
                commit('SET_RESOURCE', guidanceWorkplace);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((guidanceWorkplace) => {
                commit('SET_RESOURCE', guidanceWorkplace);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    guidanceWorkplace: state => state.guidanceWorkplace,
    dropdown: (state) => {
        return state.list.map(guidanceWorkplace => ({
            id: guidanceWorkplace.id,
            name: guidanceWorkplace.request_type
        }));
    },
    url: state => state.url,
};

const guidanceWorkplaces = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default guidanceWorkplaces;
